import { FC } from 'react'

import styled from 'styled-components'

import { variables } from 'src/Styled/variables'
import { CTAButton } from 'src/Components/Buttons/CTAButton'

const InfoText = styled.span`
  color: ${({ theme }) => theme.color.darkGrey};
  text-align: center;
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
`

const TitleText = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  text-align: center;
  font-size: ${variables.fontSize18};
  font-style: normal;
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const StyledCTAButton = styled(CTAButton)`
  padding: 0 40px;
`

interface ApprovedInfoContentProps {
  onStartCampaignClick?: () => void
}

export const ApprovedInfoContent: FC<ApprovedInfoContentProps> = ({
  onStartCampaignClick,
}) => (
  <>
    <TextWrapper>
      <TitleText>Approved to start</TitleText>
      <InfoText>
        Your track has been successfully reviewed by our team! Now, let&apos;s
        pitch your track to Spotify playlist curators.
      </InfoText>
    </TextWrapper>
    <StyledCTAButton onClick={onStartCampaignClick}>
      Start Campaign
    </StyledCTAButton>
  </>
)
